<script lang="ts">
	import { Dialog as DialogPrimitive, type WithoutChildrenOrChild } from "bits-ui";
	import { type WithChildren, box, mergeProps } from "svelte-toolbelt";
	import Mounted from "../utils/mounted.svelte";
	import type { ContentProps } from "./index.js";
	import { useDrawerContent } from "../../vaul.svelte.js";
	import { noop } from "../../internal/helpers/noop.js";
	import { useId } from "../../internal/use-id.js";

	let {
		id = useId(),
		ref = $bindable(null),
		onOpenAutoFocus = noop,
		onInteractOutside = noop,
		oncontextmenu = noop,
		onpointerdown = noop,
		onpointerup = noop,
		onpointerout = noop,
		onpointermove = noop,
		children,
		preventScroll = true,
		...restProps
	}: WithChildren<WithoutChildrenOrChild<ContentProps>> = $props();

	const contentState = useDrawerContent({
		id: box.with(() => id),
		ref: box.with(
			() => ref,
			(v) => (ref = v)
		),
		onContextMenu: box.with(() => oncontextmenu ?? noop),
		onInteractOutside: box.with(() => onInteractOutside),
		onPointerDown: box.with(() => onpointerdown ?? noop),
		onPointerMove: box.with(() => onpointermove ?? noop),
		onPointerOut: box.with(() => onpointerout ?? noop),
		onPointerUp: box.with(() => onpointerup ?? noop),
		onOpenAutoFocus: box.with(() => onOpenAutoFocus),
	});

	const mergedProps = $derived(mergeProps(restProps, contentState.props));
</script>

<DialogPrimitive.Content
	{...mergedProps}
	{preventScroll}
	onInteractOutside={contentState.onInteractOutside}
	onFocusOutside={contentState.onFocusOutside}
	onOpenAutoFocus={contentState.onOpenAutoFocus}
>
	{@render children?.()}
	<Mounted onMounted={(m) => (contentState.mounted = m)} />
</DialogPrimitive.Content>
